import React from "react";
import { Link } from "react-router-dom";
import { LOGO } from "../data/assets";

const Logo = ({ size = "md", className = "" }) => {
  const heights = { sm: 50, md: 70, lg: 100 };
  return (
    <Link to="/" className={`inline-flex items-center group ${className}`}>
      <img
        src={LOGO}
        alt="CASA BALA"
        style={{ height: heights[size] }}
        className="transition-opacity duration-300 group-hover:opacity-80 object-contain"
      />
    </Link>
  );
};

export default Logo;
